import type { SupplierRow } from './SupplierList.types'

export function mapApiDataToRows(
  data: {
    id: number
    name: string
    type: string
    blanket: boolean
    documentsLabel: string
    documentsUrl?: string
    authorizedOems: string[]
  }[],
): SupplierRow[] {
  return data.map(s => ({
    id: s.id,
    name: s.name,
    type: s.type,
    blanket: s.blanket,
    documentsLabel: s.documentsLabel,
    documentsUrl: s.documentsUrl ?? '',
    authorizedOems: s.authorizedOems,
  }))
}

export function approveSupplierRow(
  row: SupplierRow,
  setPendingRows: React.Dispatch<React.SetStateAction<SupplierRow[]>>,
  setRows: React.Dispatch<React.SetStateAction<SupplierRow[]>>,
): void {
  setPendingRows(prev => prev.filter(r => r.id !== row.id))
  setRows(prev => [row, ...prev])
}
